module.exports = __webpack_public_path__ + "static/img/logo2.995b51e7.png";